<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">类型:</div>
        <Select
          v-model="parameter.type"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option :value="0">弹窗</Option>
          <Option :value="1">悬浮窗</Option>
          <Option :value="2">功能导航</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option :value="0">禁用</Option>
          <Option :value="1">正常</Option>
        </Select>
      </div>
      <div class="search_list">
        <Button
          @click="
            upData = {};
            title = '添加';
            Show = true;
          "
          style="margin-left: 15px"
          type="primary"
          >添加</Button
        >
      </div>
    </div>
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="pic">
        <img style="width: 100px" :src="row.pic" alt="" srcset="" />
      </template>
      <template slot-scope="{ row, index }" slot="type">
        <div v-if="row.type == 0">弹窗</div>
        <div v-if="row.type == 1">悬浮窗</div>
        <div v-if="row.type == 2">功能导航</div>
      </template>
      <template slot-scope="{ row, index }" slot="visible">
        <div v-if="row.visible == 0">所有人</div>
        <div v-if="row.visible == 1">指定</div>
      </template>
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 0">禁用</div>
        <div v-if="row.state == 1">正常</div>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >编辑</Button
        >
        <Button
          v-if="row.visible == 1"
          @click="
            upData = row;
            PopupsUserList();
            title = '用户';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >用户</Button
        >
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal
      width="800"
      v-model="UserDelShow"
      :title="title"
      @on-ok="PopupsUserDel"
      >删除</Modal
    >
    <Modal
      width="800"
      v-model="UserAddShow"
      title="添加用户"
      @on-ok="PopupsUserAdd"
      >添加</Modal
    >
    <Modal width="1200" v-model="UserShow" :title="title">
      <div class="search_list">
        <div class="text">姓名/账号:</div>
        <Input
          v-model="keyword"
          @input="
            pageNow2 = 1;
            getUserData();
          "
          search
          class="select"
        />
      </div>
      <Table
        border
        class="table_style"
        :columns="columns2"
        :data="userData.list"
        :highlight-row="true"
      >
        <template slot-scope="{ row, index }" slot="config">
          <Button
            @click="
              UserAddShow = true;
              selectUserAdd = row;
            "
            style="margin-right: 15px"
            type="primary"
            >添加</Button
          >
        </template>
      </Table>
      <Page :total="userData.total" @on-change="switchover2"
    /></Modal>
    <Modal width="800" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>
      <div v-else-if="title == '用户'">
        <Button
          @click="
            getUserData();
            UserShow = true;
          "
          style="margin-left: 15px"
          type="primary"
          >添加</Button
        >
        <Table
          border
          class="table_style"
          :columns="columns1"
          :data="selectUserList.list"
          :highlight-row="true"
        >
          <template slot-scope="{ row, index }" slot="config">
            <Button
              @click="
                upDataUser = row;
                UserDelShow = true;
              "
              style="margin-right: 15px"
              type="primary"
              >删除</Button
            >
          </template>
        </Table>
        <Page :total="selectUserList.total" @on-change="switchover1" />
      </div>
      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>标题:</div>
          <div>
            <Input
              v-model="upData.title"
              placeholder="名称"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <div>图片:</div>
          <Upload
            :on-success="handleSuccess"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            action="api/v1/product/uploads"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
          <img style="width: 100px" :src="upData.pic" alt="" />
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>跳转地址:</div>
          <div>
            <Input
              v-model="upData.url"
              placeholder="跳转地址"
              style="width: 300px"
            />
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>类型:</div>
          <div>
            <Select v-model="upData.type">
              <Option :value="0">弹窗</Option>
              <Option :value="1">悬浮窗</Option>
              <Option :value="2">功能导航</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>可见范围:</div>
          <div>
            <Select v-model="upData.visible">
              <Option :value="0">所有人</Option>
              <Option :value="1">指定</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态:</div>
          <div>
            <Select v-model="upData.state">
              <Option :value="0">禁用</Option>
              <Option :value="1">正常</Option>
            </Select>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>排序/降序:</div>
          <div>
            <Input
              v-model="upData.sort"
              placeholder="排序/降序"
              style="width: 300px"
            />
          </div>
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      queryList: [],
      userList: { list: [] },
      selectUserList: { list: [] },
      UserDelShow: false,
      UserShow: false,
      keyword: "",
      title: "",
      UserAddShow: false,
      upData: {},
      selectUserAdd: {},
      upDataUser: {},
      Show: false,
      parameter: {
        pageNow: 1,
      },
      pageNow2: 1,
      userData: { list: [] },
      pageNow1: 1,
      columns2: [
        {
          title: "用户名",
          align: "center",
          key: "username",
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
        },
        {
          title: "团队名称",
          align: "center",
          key: "groupName",
        },
        {
          title: "证件号码 ",
          align: "center",
          key: "idNo",
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "config",
          fixed: "right",
        },
      ],
      columns1: [
        {
          title: "主键id",
          className: "fontcolor",
          align: "center",
          key: "id",
        },
        {
          title: "用户手机号",
          className: "fontcolor",
          align: "center",
          key: "phone",
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          width: 150,
          fixed: "right",
        },
      ],
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
          width: 50,
        },
        {
          title: "标题",
          className: "fontcolor",
          align: "center",
          key: "title",
          width: 200,
        },
        {
          title: "图片",
          align: "center",
          className: "fontcolor",
          slot: "pic",
          width: 200,
        },
        {
          title: "跳转地址",
          align: "center",
          key: "url",
          className: "fontcolor",
          width: 200,
        },
        {
          title: "类型",
          align: "center",
          slot: "type",
          className: "fontcolor",
          width: 100,
        },
        {
          title: "可见范围",
          align: "center",
          slot: "visible",
          className: "fontcolor",
          width: 100,
        },
        {
          title: "状态",
          align: "center",
          slot: "state",
          className: "fontcolor",
          width: 100,
        },
        {
          title: "排序/降序",
          className: "fontcolor",
          align: "center",
          key: "sort",
          width: 100,
        },
        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime",
          width: 200,
        },
        {
          title: "修改时间",
          className: "fontcolor",
          align: "center",
          key: "modifyTime",
          width: 200,
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    api
      .OutsideGroupQueryList({
        pageNow: 1,
        pageSize: 99999,
      })
      .then((res) => {
        this.queryList = res.body.data.list;
      });
    this.getData();
  },
  methods: {
    PopupsUserList() {
      api
        .PopupsUserList({
          pageNow: this.pageNow1,
          popupsId: this.upData.id,
        })
        .then((res) => {
          this.selectUserList = res.body.data;
        });
    },
    getUserData() {
      api
        .UserList({
          pageNow: this.pageNow2,
          keyword: this.keyword,
          pageSize: 10,
        })
        .then((res) => {
          this.userData = res.body.data;
        });
    },
    handleSuccess(res, file) {
      this.upData.pic = res.data[0].path;
      this.$forceUpdate();
    },

    PopupsUserAdd() {
      api
        .PopupsUserAdd({
          popupsId: this.upData.id,
          userId: this.selectUserAdd.id,
        })
        .then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.PopupsUserList();
        });
    },
    PopupsUserDel() {
      api.PopupsUserDel(this.upDataUser.id).then((res) => {
        if (res.body.status) {
          this.$Message.info(res.body.message);
        }
        this.PopupsUserList();
      });
    },
    UaorderShip() {
      if (this.title == "添加") {
        api.PopupsAdd(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "编辑") {
        api.PopupsEdit(this.upData).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.PopupsDel(this.upData.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },
    switchover1(pageNow) {
      this.pageNow1 = pageNow;
      this.PopupsUserList();
    },
    switchover2(pageNow) {
      this.pageNow2 = pageNow;
      this.getUserData();
    },

    getData() {
      api.PopupsList(this.parameter).then((res) => {
        this.userList = res.body.data;
      });
    },
  },
};
</script>

<style scoped>
</style>